import { render, staticRenderFns } from "./ViewOurTerms.vue?vue&type=template&id=2a0d0442&scoped=true"
import script from "./ViewOurTerms.vue?vue&type=script&lang=js"
export * from "./ViewOurTerms.vue?vue&type=script&lang=js"
import style0 from "./ViewOurTerms.vue?vue&type=style&index=0&id=2a0d0442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d0442",
  null
  
)

export default component.exports